import gql from 'graphql-tag';

export class SignupMutations {
  static signupMutation = gql`
    mutation Signup($email: String!, $registrationSource: String!, $sourceDetails: String) {
      signup(
        email: $email
        registrationSource: $registrationSource
        sourceDetails: $sourceDetails
      ) {
        redirectUrl
        error
        didYouMean
      }
    }
  `;
}
